import { render } from "./recoverpwd.vue?vue&type=template&id=417e41b9"
import script from "./recoverpwd.vue?vue&type=script&lang=js"
export * from "./recoverpwd.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\EZELINK\\Wajiha\\Projects\\EzenmsV2_vueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__